import { ElementRef } from '@angular/core';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { REPORT_BRANDING_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/urls.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "@angular/common";
function AccountSettingsNavigationComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 2);
    i0.ɵɵelement(1, "a", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", tab_r1.label === ctx_r1.selectedTab);
    i0.ɵɵproperty("href", tab_r1.url, i0.ɵɵsanitizeUrl)("textContent", tab_r1.label);
} }
export class AccountSettingsNavigationComponent {
    constructor(eltRef, urlsService, featureService) {
        this.eltRef = eltRef;
        this.urlsService = urlsService;
        this.featureService = featureService;
        this.NAVIGATION_TABS = [
            {
                label: 'Account Basics',
                url: this.urlsService.ACCOUNTS.ACCOUNT_BASICS,
            },
            {
                label: 'Membership',
                url: this.urlsService.ACCOUNTS.MEMBERSHIP,
            },
            {
                label: 'User Preferences',
                url: this.urlsService.ACCOUNTS.USER_PREFERENCE_SETTINGS,
            },
            {
                label: 'Report History',
                url: this.urlsService.ACCOUNTS.REPORT_HISTORY,
            },
            {
                label: 'Share Groups',
                url: this.urlsService.ACCOUNTS.SHARE_GROUPS_PAGE,
            },
            {
                label: 'Integrations',
                url: this.urlsService.ACCOUNTS.INTEGRATIONS,
            },
        ];
        this.selectedTab = this.eltRef.nativeElement.getAttribute('currentTab');
        if (this.featureService.userHasFeatures([REPORT_BRANDING_FEATURE])) {
            this.NAVIGATION_TABS.splice(5, 0, {
                label: 'Report Branding',
                url: this.urlsService.ACCOUNTS.REPORT_DISPLAY_SETTINGS,
            });
        }
        const billingAdmin = this.eltRef.nativeElement.getAttribute('billingAdmin') === 'True';
        if (billingAdmin) {
            this.NAVIGATION_TABS.splice(2, 0, {
                label: 'Payment & Billing',
                url: this.urlsService.ACCOUNTS.BILLING_INFO,
            });
        }
    }
}
AccountSettingsNavigationComponent.ɵfac = function AccountSettingsNavigationComponent_Factory(t) { return new (t || AccountSettingsNavigationComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.UrlsService), i0.ɵɵdirectiveInject(i2.FeatureService)); };
AccountSettingsNavigationComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AccountSettingsNavigationComponent, selectors: [["ycn-account-settings-navigation"]], decls: 2, vars: 1, consts: [[1, "nav", "nav-tabs"], ["class", "nav-item", 4, "ngFor", "ngForOf"], [1, "nav-item"], [1, "nav-link", 3, "href", "textContent"]], template: function AccountSettingsNavigationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ul", 0);
        i0.ɵɵtemplate(1, AccountSettingsNavigationComponent_li_1_Template, 2, 4, "li", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.NAVIGATION_TABS);
    } }, dependencies: [i3.NgForOf], encapsulation: 2 });
